<template>
  <v-row class="no-gutters flex-wrap">
    <v-col cols="12">
      <v-sheet rounded="lg" class="pa-2">
        <v-row class="align-center justify-center" dense>
          <v-col cols="auto">
            <v-img
              :src="require('@/assets/nentwichVerlag_logos_color.svg')"
              class="hidden-xs-only"
              height="90"
              width="200"
              contain
            ></v-img>
          </v-col>
          <v-col cols="auto">
            <div class="primary--text">
              <h1 :class="isMdAndUp ? 'text-h4 font-weight-bold mb-3' : 'text-h5 font-weight-bold'">
                Noten bestellen
              </h1>
            </div>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
    <v-col cols="12">
      <Overview />
    </v-col>
  </v-row>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import Overview from '@/components/scores/Overview.vue';

export default {
  name: 'ShopHome',
  components: {
    Overview,
  },
  setup() {
    const store = useStore();
    const isMdAndUp = computed(() => store.getters['display/mdAndUp']);

    return {
      isMdAndUp,
    };
  },
};
</script>
